import styled from "@emotion/styled/macro";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { Button, IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import Box from "@mui/material/Box";

export const StyledWhiteContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status }) => {
  return {
    borderRadius: "4px",
    background: "#FFF",
    boxShadow: " 0px 0px 20px 0px rgba(0, 0, 0, 0.05)",
    marginBottom: "8px",
  };
});

export const StyledWhiteInsidePadding = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status }) => {
  return {
    padding: "20px 24px",
  };
});

export const StyledSettingItemTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status, readonly }) => {
  return {
    color: theme.customColors.grey[700],
    fontWeight: 700,
    marginBottom: "4px",
    display: "flex",
    alignItems: "center",
    ...(readonly && {
      marginBottom: "12px",
    }),
  };
});

export const StyledSettingItemTinyTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status, readonly }) => {
  return {
    fontSize: "12px",
    fontWeight: 400,
    color: theme.customColors.grey[500],
  };
});

export const StyledSettingItemDescription = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status, sx }) => {
  return {
    color: theme.customColors.grey[600],
    marginBottom: "20px",
    lineHeight: "normal",
    ...sx,
  };
});

export const StyledSettingItemInfo = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status, sx }) => {
  return {
    color: theme.customColors.grey[700],
    lineHeight: "normal",
    ...sx,
  };
});

export const StyledSettingItemLink = styled("a", {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, status, sx }) => {
  return {
    color: "#1D5EB9",
    textDecoration: "none",
    wordBreak: "break-all",
    "&:hover": {
      color: "#1D5EB9",
    },
    ...sx,
  };
});

export const StyledInputTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, isRequired, errors }) => {
  return {
    marginBottom: "4px",
    color: theme.customColors.grey[700],

    ...(errors && {
      color: theme.customColors.pink[600],
    }),

    ...(isRequired && {
      "&:after": {
        content: '"*"',
        color: theme.customColors.pink[600],
        marginLeft: "3px",
      },
    }),
  };
});
